export const FETCH_SEARCH_RESULT_INIT =
  'app/JobSearch/FETCH_SEARCH_RESULT_INIT';
export const FETCH_SEARCH_RESULT_SUCCESS =
  'app/JobSearch/FETCH_SEARCH_RESULT_SUCCESS';
export const FETCH_SEARCH_RESULT_ERROR =
  'app/JobSearch/FETCH_SEARCH_RESULT_ERROR';
